export default __webpack_public_path__ + "static/media/robot.85af95a5.svg";